var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone, mic, sound, podcast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M10.0001 16.7853V18.452M10.0001 16.7853C6.93492 16.7853 5.12245 14.9062 4.17871 13.452M10.0001 16.7853C13.0653 16.7853 14.8778 14.9062 15.8215 13.452M13.3334 6.7853V10.1186C13.3334 11.9596 11.8411 13.452 10.0001 13.452C8.15915 13.452 6.66677 11.9596 6.66677 10.1186V6.7853C6.66677 4.94435 8.15915 3.45197 10.0001 3.45197C11.8411 3.45197 13.3334 4.94435 13.3334 6.7853Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.60af98592a74ce88d0668d8dcee8d889.svg";
export { ForwardRef as ReactComponent };